export enum Types {
	EXCLUIR_PARAMETRO_SISTEMA = '@SGU/EXCLUIR_PARAMETRO_SISTEMA',
	EXCLUIR_PARAMETRO_SISTEMA_SUCCESS = '@SGU/EXCLUIR_PARAMETRO_SISTEMA_SUCCESS',
	EXCLUIR_PARAMETRO_SISTEMA_FAILURE = '@SGU/EXCLUIR_PARAMETRO_SISTEMA_FAILURE',
	EXCLUIR_PARAMETRO_SISTEMA_CLEAR = '@SGU/EXCLUIR_PARAMETRO_SISTEMA_CLEAR',
}

export interface ExcluirParametroSistema {
	status: number;
	data: null | ParametroSistemaData;
}

interface ParametroSistemaData {
	status: string;
	statusMensagem: string;
}

export interface ExcluirParametroSistemaRequest {
	id?: number | string;
	sigla: string;
	descricao: string;
	valor: string;
}
